import styled from "styled-components";
import { tablet } from "../responsive";
export const NoInstances = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5rem;

  .rag-btn {
    margin-top: 2rem;
    text-align: center;
    color: white;
    background-color: #ff363f;
    padding: 0.5rem;
    border-radius: 30px;
  }
`;

export const StyledProject = styled.div`
  display: flex;
  justify-content: center;
  padding: 2rem;
  max-width: 100%;
  overflow-x: auto;
  flex-direction: column;
  .header {
    margin-bottom: 2rem;

    h1 {
      margin-bottom: 1rem;
    }
  }
  table {
    border-spacing: 0;
    border: 1px solid darkgrey;
    text-align: center;

    ${tablet({ fontSize: "0.7rem" })}

    .link {
      transition: all 0.2s ease-in-out;
      &:hover {
        color: #2797fe;
      }
    }
    tr {
      height: 5rem;
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    th {
      background-color: #323232;
      color: white;
    }
    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid darkgrey;
      border-right: 1px solid darkgrey;
      :last-child {
        border-right: 0;
      }
    }
  }
  .MuiDataGrid-cell--textLeft {
    text-align: center;
  }
`;
